module.exports = __webpack_public_path__ + "img/flowers-right-vertical.0a8b6223.png";